import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldAlert, Home, RefreshCw } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div
        className="min-h-screen w-full flex items-center justify-center"
        style={{
          background: 'linear-gradient(to bottom, #eff6ff, #ecfeff)',
          fontFamily: 'Inter, Arial, sans-serif',
        }}
      >
        <div className="max-w-lg w-full mx-auto px-6 py-16">
          <div className="bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">
            <div className="h-1 w-full" style={{ background: 'linear-gradient(to right, #dc2626, #f97316)' }} />

            <div className="px-8 sm:px-14 py-14 flex flex-col items-center text-center">
              <div
                className="w-20 h-20 rounded-full flex items-center justify-center mb-6"
                style={{ background: 'linear-gradient(135deg, #fee2e2, #fecaca)' }}
              >
                <ShieldAlert className="w-10 h-10 text-red-500" />
              </div>

              <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">
                Something Went Wrong
              </h1>

              <p className="text-gray-500 text-sm mb-8 max-w-sm leading-relaxed">
                An unexpected error occurred. You can try refreshing the page or navigate back to the homepage.
              </p>

              <div className="flex flex-col sm:flex-row items-center gap-3 w-full">
                <button
                  onClick={() => {
                    this.handleReset();
                    window.location.reload();
                  }}
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg text-white font-semibold text-sm shadow-sm hover:shadow-md transition w-full sm:w-auto"
                  style={{ background: 'linear-gradient(to right, #1d4ed8, #0891b2)' }}
                >
                  <RefreshCw className="w-4 h-4" />
                  Refresh Page
                </button>
                <Link
                  to="/dpdp"
                  onClick={this.handleReset}
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg border border-gray-200 text-gray-700 font-semibold text-sm hover:bg-gray-50 transition w-full sm:w-auto"
                >
                  <Home className="w-4 h-4" />
                  Go to Homepage
                </Link>
              </div>
            </div>
          </div>

          <p className="text-center text-xs text-gray-400 mt-8">
            If this keeps happening, please <Link to="/contact-us" onClick={this.handleReset} className="underline text-blue-600">contact us</Link>.
          </p>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
